// extracted by mini-css-extract-plugin
export default {"button":"SortButton_button__sC7oL"};